import { PipelineMonitorsQuery } from '@optools/services/operator-gateway/types/generated/graphql';

export const DEV_CONFIG_REGEX_PATTERN = /DEV(\d+)/;

export const filterAndSortDevPipelineMonitors = (
  monitors: PipelineMonitorsQuery['pipelineMonitors'],
) => {
  return (
    monitors
      .filter(({ pipelineConfig }) => {
        return DEV_CONFIG_REGEX_PATTERN.test(pipelineConfig?.fronthaulDecoderServiceLabel ?? '');
      })
      .toSorted((a, b) => {
        const labelA = a.pipelineConfig?.fronthaulDecoderServiceLabel ?? '';
        const labelB = b.pipelineConfig?.fronthaulDecoderServiceLabel ?? '';

        const numA = parseInt(labelA.match(DEV_CONFIG_REGEX_PATTERN)?.[1] ?? '0', 10);
        const numB = parseInt(labelB.match(DEV_CONFIG_REGEX_PATTERN)?.[1] ?? '0', 10);

        return numA - numB;
      }) ?? []
  );
};

export const getConfigNumberFromLabel = (label: string) => {
  const match = label?.match(DEV_CONFIG_REGEX_PATTERN);
  return match ? match[0] : '';
};

export const filterAndSortBorrowedProdPipelineMonitors = (
  monitors: PipelineMonitorsQuery['pipelineMonitors'],
) => {
  const filteredMonitors = monitors.filter(({ pipelineConfig }) => {
    return (
      pipelineConfig &&
      !DEV_CONFIG_REGEX_PATTERN.test(pipelineConfig.fronthaulDecoderServiceLabel ?? '') &&
      pipelineConfig.teamId &&
      pipelineConfig.teamId > 0
    );
  });

  return filteredMonitors;
};
